// Logged-in app page: hook collections (routes/Hooks.tsx).
// Keep keys in sync with en/appHooks.ts. Sesja 10 (artboardy 14-15): jedno zdanie kontekstu bez
// angielskiego słowa (G6-library-11/-29), grupy rodzin z polem wyboru całej grupy, błąd z powodem
// i ponowieniem (G6-library-23). Zero znaków obrazkowych w copy.
//
// PACZKA 34 (MINIMAL-2026-09-18, MAPA sesji 34 po R2). Zmienione brzmienia:
//   · zasada 8 — drugie zdania pustych stanów, „Spróbuj ponownie.” w błędzie zapisu paczki
//     i „zaznaczenie zostało zachowane” wypadają; zostaje JEDNO zdanie i jedna droga;
//   · tytuły okien kasujących bez nawiasu („Usunąć 3 hooki?”), bo nazwa i liczba stoją w liście;
// P2-D (21.09): blok `generator` usunięty razem z generatorem hooków; jego reguła
// `unknown-placeholder` żyje dalej jako `coll.unknownPlaceholder`.
// Klucze, które przestały być wołane (`state.empty*`, `library.emptyAllBody`, `choosePackPromptBody`,
// `form.desc`, `form.tags`, `library.rename`), zostają w słowniku: usuwa je właściciel języka,
// nie paczka ekranu.
export const appHooks = {
  head: {
    title: 'Hooki',
  },
  intro: {
    title: 'Napisy na filmie przyciągające uwagę',
  },
  // OKNO „ZMIENNE” (reguła 33, runda B-R3). Wyłącznie zmienne, które parser
  // podstawia dzisiaj (`lib/textTemplates.ts`). Przykład to WYNIK podstawienia,
  // nie zapis zmiennej: wiersz ma pokazać, co zobaczy widz, nie powtórzyć nazwę.
  // Grupa „Losowe” czeka na `{random_emoji}` z reguły 33 — nagłówek bez wierszy
  // się nie renderuje.
  variables: {
    label: 'Zmienne',
    intro: 'Wartości wpisujesz przy planowaniu paczki do publikacji.',
    fixed: 'Stałe',
    random: 'Losowe',
    artist: 'nazwa artysty',
    artistExample: 'Nocna Zmiana znowu to zrobił',
    title: 'tytuł utworu',
    titleExample: 'Mokry asfalt na słuchawkach',
    timestamp: 'moment utworu',
    timestampExample: 'moment w 0:31 jest przepotężny',
    // Nazwy dla czytnika ekranu; {variable} podstawia komponent.
    insert: 'Wstaw {variable}',
    copy: 'Kopiuj {variable}',
    copied: 'Skopiowano',
    copyFailed: 'Nie udało się skopiować.',
    close: 'Zamknij',
  },
  list: {
    heading: 'Paczki',
    collection_one: 'paczka',
    collection_few: 'paczki',
    collection_many: 'paczek',
    hooks_one: 'hook',
    hooks_few: 'hooki',
    hooks_many: 'hooków',
    newCollection: 'Nowa paczka',
  },
  form: {
    name: 'Nazwa',
    namePlaceholder: 'np. Hooki na start',
    desc: 'Opis',
    descPlaceholder: 'Opcjonalnie',
    create: 'Utwórz',
    cancel: 'Anuluj',
  },
  state: {
    loadError: 'Nie udało się wczytać paczki.',
    emptyTitle: 'Nie masz jeszcze własnych paczek',
    emptyBody: 'Hooki to krótkie napisy na górze edita. Stwórz paczkę, a EDIMI będzie losować z niej jeden na początku każdej serii.',
    emptyBodyWithSystem: '{n} gotowych od EDIMI jest wyżej i możesz ich użyć od razu. Własną stworzysz, gdy będziesz chciał ciąć po swojemu.',
    emptyBodyWithSystem_one: 'Jedna gotowa od EDIMI jest wyżej i możesz jej użyć od razu. Własną stworzysz, gdy będziesz chciał ciąć po swojemu.',
    emptyBodyWithSystem_few: '{n} gotowe od EDIMI są wyżej i możesz ich użyć od razu. Własną stworzysz, gdy będziesz chciał ciąć po swojemu.',
    emptyBodyWithSystem_many: '{n} gotowych od EDIMI jest wyżej i możesz ich użyć od razu. Własną stworzysz, gdy będziesz chciał ciąć po swojemu.',
  },
  coll: {
    own: 'własna',
    // Jedyna reguła lintu, którą klient zna sam (`hookValidation`); przeniesiona z bloku
    // generatora, który zniknął razem z generatorem (P2-D).
    unknownPlaceholder: 'nieznany placeholder - nie mamy czym go podstawić',
    more: 'Więcej akcji: {name}',
    expand: 'Rozwiń paczkę {name}',
    collapse: 'Zwiń paczkę {name}',
    deleteCollectionTitle: 'Usuń paczkę',
    deleteAsk: 'Usunąć paczkę?',
    deleteRow: 'Hooki',
    emptyItems: 'Brak hooków',
    deleteItemTitle: 'Usuń hook',
    deleteItemLabel: 'Usuń hook „{text}”',
    deleteItemAsk: 'Usunąć hook „{text}”?',
    addHeading: 'Dodaj hooki',
    add: 'Dodaj',
    pasteCount: '{count} hooków do dodania',
    pasteCount_one: '{count} hook do dodania',
    pasteCount_few: '{count} hooki do dodania',
    pasteCount_many: '{count} hooków do dodania',
    addN: 'Dodaj {count} hooków',
    addN_one: 'Dodaj {count} hook',
    addN_few: 'Dodaj {count} hooki',
    addN_many: 'Dodaj {count} hooków',
  },
  system: {
    readOnly: 'tylko do odczytu',
    count: '{n} · gotowe do użycia',
    copyToMine: 'Kopiuj do moich',
    copyDone: 'Skopiowano do moich paczek.',
    heading: 'Paczki EDIMI',
    andMore: '…i {count} kolejnych',
  },
  library: {
    mine: 'Moje',
    all: 'Wszystkie paczki',
    edimi: 'EDIMI',
    newPack: 'Nowa paczka',
    save: 'Zapisz',
    rename: 'Zmień nazwę',
    openPack: 'Otwórz {name}',
    selectPack: 'Zaznacz paczkę „{name}”',
    deletePack: 'Usuń paczkę',
    deletePacksAsk: 'Usunąć {count} paczek?',
    deletePacksAsk_one: 'Usunąć paczkę?',
    deletePacksAsk_few: 'Usunąć {count} paczki?',
    deletePacksAsk_many: 'Usunąć {count} paczek?',
    deletePacksDo: 'Usuń {count} paczek',
    deletePacksDo_one: 'Usuń paczkę',
    deletePacksDo_few: 'Usuń {count} paczki',
    deletePacksDo_many: 'Usuń {count} paczek',
    selected: 'zaznaczone',
    // Czasownik, nie samo słowo zbioru: obok stoi pigułka zakresu „Wszystkie”,
    // a te dwa przyciski robią rzeczy przeciwne (przegląd D).
    selectAll: 'Zaznacz wszystkie',
    selectNone: 'Żadna',
    emptyAll: 'Brak paczek hooków',
    emptyAllBody: 'Utwórz własną paczkę albo otwórz EDIMI, żeby zacząć.',
    emptyEdimi: 'Brak paczek EDIMI',
    emptyEdimiBody: 'Gdy paczki EDIMI będą dostępne w tym języku, pojawią się tutaj.',
    choosePackPrompt: 'Wybierz paczkę',
    choosePackPromptBody: 'Hooki z wybranej paczki pojawią się tutaj.',
    actionFailed: 'Nie udało się wykonać operacji.',
    back: 'Hooki',
    selectItem: 'Zaznacz hook „{text}”',
    moveItems: 'Przenieś do innej paczki',
    copyItems: 'Kopiuj do innej paczki',
    deleteItemsAsk: 'Usunąć {count} hooków?',
    deleteItemsAsk_one: 'Usunąć hook?',
    deleteItemsAsk_few: 'Usunąć {count} hooki?',
    deleteItemsAsk_many: 'Usunąć {count} hooków?',
    deleteItemsDo: 'Usuń {count} hooków',
    deleteItemsDo_one: 'Usuń hook',
    deleteItemsDo_few: 'Usuń {count} hooki',
    deleteItemsDo_many: 'Usuń {count} hooków',
    addRules: 'Jeden hook na linię · krótko i o muzyce · używaj {artist} i {timestamp} jako zmiennych',
    targetPack: 'Paczka docelowa',
    choosePack: 'Wybierz paczkę',
    confirmMove: 'Przenieś {count} hooków',
    confirmMove_one: 'Przenieś {count} hook',
    confirmMove_few: 'Przenieś {count} hooki',
    confirmMove_many: 'Przenieś {count} hooków',
    confirmCopy: 'Kopiuj {count} hooków',
    confirmCopy_one: 'Kopiuj {count} hook',
    confirmCopy_few: 'Kopiuj {count} hooki',
    confirmCopy_many: 'Kopiuj {count} hooków',
    noTarget: 'Nie masz innej własnej paczki.',
    noTargetBody: 'Najpierw utwórz pustą paczkę hooków.',
    errorConflict: 'W paczce docelowej jest inny hook pod tym samym miejscem.',
    errorChanged: 'Zawartość paczki zmieniła się w trakcie operacji.',
    errorMissing: 'Jednego z hooków albo paczki już nie ma.',
    errorSame: 'Wybierz inną paczkę docelową.',
    errorGeneric: 'Nie udało się wykonać operacji.',
    invalid: 'Popraw tekst przed dodaniem',
    retry: 'Spróbuj ponownie',
    newPackFailed: 'Nie udało się utworzyć paczki.',
    // Paczka 34: ciche akcje półki, pasek zaznaczenia i jedno zdanie nieodwracalności.
    select: 'Zaznacz',
    selectedCount: 'Zaznaczone: {count}',
    deleteCount: 'Usuń ({count})',
    moveShort: 'Przenieś',
    copyShort: 'Kopiuj',
    loadFailed: 'Nie udało się wczytać paczek hooków.',
    invalidLine: 'linia {line} {reason}',
    toastAdded: 'Dodano {count} hooków.',
    toastAdded_one: 'Dodano {count} hook.',
    toastAdded_few: 'Dodano {count} hooki.',
    toastAdded_many: 'Dodano {count} hooków.',
    toastMoved: 'Przeniesiono {count} hooków do paczki „{name}”.',
    toastMoved_one: 'Przeniesiono {count} hook do paczki „{name}”.',
    toastMoved_few: 'Przeniesiono {count} hooki do paczki „{name}”.',
    toastMoved_many: 'Przeniesiono {count} hooków do paczki „{name}”.',
    toastCopied: 'Skopiowano {count} hooków do paczki „{name}”.',
    toastCopied_one: 'Skopiowano {count} hook do paczki „{name}”.',
    toastCopied_few: 'Skopiowano {count} hooki do paczki „{name}”.',
    toastCopied_many: 'Skopiowano {count} hooków do paczki „{name}”.',
    toastPackDeleted: 'Paczka usunięta.',
    toastPackDeleteFailed: 'Nie udało się usunąć paczki.',
  },
  // Runda 33-R4 (reguła 57): pole dodawania ma etykietę i licznik linii jako DANĄ;
  // zdanie o regułach pod polem wypadło (reguła 8).
  field: {
    label: 'Nowe hooki',
    placeholder: 'jeden hook w linii',
    lines_one: '{count} linia',
    lines_few: '{count} linie',
    lines_many: '{count} linii',
  },
}
